import React from 'react';
import "./index.scss";

const NoDataFound = () => {
  return (
    <div className="no-data-found">No Data Found</div>
  )
}

export default NoDataFound